import React, { useState, useEffect } from 'react';
import { Button, Popper, Grow, Paper, MenuList, MenuItem } from "@material-ui/core";
import { useUserSelectedExams } from "examsbook-react-sdk/custom-hooks";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

/**
 * Exam switcher component.
 * @param props
 * @returns {*}
 * @constructor
 */
function ExamSwitcher(props) {
    const [ openToggle, setOpenToggle ] = useState(false);
    const [ anchorEl, setAnchorEl ] = useState(false);

    function handleToggle() {
        setOpenToggle(true);
    }

    const handleClickAway = () => {
        setOpenToggle(false);
      };

    function handleCloseMenu(event) {
        setOpenToggle(true);
        event.preventDefault();
        if (anchorEl && anchorEl.contains(event.target)) {
            return null;
        }
    }

    //add effect to remove click event
    useEffect(() => {
        return () => {
            document.removeEventListener('click', () => {
            });
        };
    }, []);

    function addMoreExam(e) {
        handleCloseMenu(e);
        props.handleAddHeaderExam();
    }

    let { selectedExam, userSelectedExamList, changeSelectedExam } = useUserSelectedExams();

    function updateSelectedExam(event, data) {
        if (data) {
            changeSelectedExam(data._id);
        }
        handleCloseMenu(event);
        window.scrollTo(0, 0);
    }

    function setButtonRef(node) {
        if (node) {
            setAnchorEl(node);
        }
    }

    return (
        <div>
        <ClickAwayListener onClickAway={handleClickAway}>
            <Button className="toggle-btn" ref={setButtonRef}
                    aria-owns={openToggle ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}>
                {selectedExam ? selectedExam.name : ''}
                <i className="fa fa-angle-down"/>
            </Button>
            </ClickAwayListener>
            {
                anchorEl ?
                    <Popper className="toggle-menu" open={openToggle} anchorEl={anchorEl} transition disablePortal>
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                id="menu-list-grow"
                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                                <Paper>
                                    <MenuList onClick={handleCloseMenu}>
                                        {
                                            userSelectedExamList ? userSelectedExamList.map((data, key) => {
                                                return (
                                                    <MenuItem key={key}
                                                              selected={selectedExam && selectedExam.name === data.name}
                                                              onClick={(event) => updateSelectedExam(event, data)}>{data.name}</MenuItem>
                                                );
                                            }) : ''
                                        }
                                        <MenuItem className="add-more-exams"><i className="fa fa-plus"
                                                                                onClick={addMoreExam}/></MenuItem>
                                    </MenuList>
                                </Paper>
                            </Grow>
                        )}
                    </Popper> : ''
            }

        </div>
    );
}

export default ExamSwitcher;
